import { AttributesBoxPalletTruck, BoxPallet_Ledger_Report, BoxPallet_Pending_Report, BoxPallet_Report, BoxPallet_searchExactItemAPI, } from "../../Server/ApiV2";

export const onGetBoxPallet_Pending_Report = async (postData) => {
  try {
    const response = await BoxPallet_Pending_Report(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const onGetAttributesBoxPallet_Truck = async (postData) => {
  try {
    const response = await AttributesBoxPalletTruck(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const onGetBoxPallet_Ledger_Report = async (postData) => {
  try {
    const response = await BoxPallet_Ledger_Report(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};

export const onGetBoxPallet_Report = async (postData) => {
  try {
    const response = await BoxPallet_Report(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};

export const getSearchExactItemAPI = async (postData) => {
  try {
    const response = await BoxPallet_searchExactItemAPI(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
